// extracted by mini-css-extract-plugin
export var fadeOut = "shorts-module--fadeOut--98376";
export var homeButton = "shorts-module--home-button--4751e";
export var loadingWrapper = "shorts-module--loading-wrapper--879e6";
export var logo = "shorts-module--logo--32a5a";
export var muteButton = "shorts-module--mute-button--496ca";
export var navArrow = "shorts-module--nav-arrow--0775b";
export var navigationArrows = "shorts-module--navigation-arrows--1b415";
export var playIndicator = "shorts-module--play-indicator--26051";
export var shortWrapper = "shorts-module--short-wrapper--01026";
export var shortsContainer = "shorts-module--shorts-container--9917c";
export var shortsPage = "shorts-module--shorts-page--6bada";
export var swipeHint = "shorts-module--swipe-hint--14b00";
export var videoCounter = "shorts-module--video-counter--0d1c7";
export var videoFrame = "shorts-module--video-frame--d4cc3";
export var videoOverlay = "shorts-module--video-overlay--877ee";
export var videoWrapper = "shorts-module--video-wrapper--56246";